import netWorkController from "@/http/netWorkController";
import toastUtils from "@/utils/toastUtils";
import cookieUtils from "@/utils/cookieUtils";
import dateUtils from "@/utils/dateUtils";
import tipsDialog from "@/views/TipsDialog";
import upLoadLogFileDialog from "@/views/UpLoadLogFileDialog";
import pushMessageDialog from "@/views/PushMessageDialog";

export default {
    name: "DeViceListPage",
    components: {tipsDialog, upLoadLogFileDialog, pushMessageDialog},
    created() {
        const userInfoStr = window.localStorage.getItem("userInfo")
        if (userInfoStr) {
            this.userInfo = JSON.parse(userInfoStr)
            netWorkController.appList(this.userInfo.id, this.userInfo.accessToken, (result) => {
                if (result.data) {
                    this.appList = result.data
                    let appIdCache = cookieUtils.get("appIdCache")
                    if (appIdCache) {
                        this.requestForm.appId = Number.parseInt(appIdCache);
                    } else {
                        this.requestForm.appId = this.appList[0].id
                    }
                    this.pageDeviceList()
                } else {
                    toastUtils.warning(this, result.msg)
                }
            })
        }
    },
    data() {
        return {
            tipsDialogVisible: false,
            uploadLogFileDialogVisible: false,
            pushMsgDialogVisible: false,
            appList: [],
            userInfo: {},
            requestForm: {
                appId: -1,
                ///当前页数
                pageNum: 1,
                ///一页总数
                pageSize: 10,
                ///总条数
                total: 0,
                deviceCode: "",
                deviceOwner: "",
                deviceModel: "",
                deviceManufacturer: "",
                deviceSystem: "",
                appVersionName: "",
                appVersionCode: "",
                connectStatus: null
            },
            deviceList: [],
            selectedDevice: {},
            messageTypes: {S_UPLOAD_LOG: "S_UPLOAD_LOG"},
        }
    },
    methods: {
        upLoadLogFileBtnClick(device) {
            this.selectedDevice = device;
            this.uploadLogFileDialogVisible = true;
        },
        upLoadLogFileClick(value) {
            this.uploadLogFileDialogVisible = false;
            if (value && this.selectedDevice) {
                let messageContent = value[0];
                if (value.length > 1) {
                    messageContent = value[0] + "," + value[1]
                }
                this.pushMsg(messageContent, this.messageTypes.S_UPLOAD_LOG)
            }
        },
        onlineLogClick(device) {
            if (device) {
                window.doOpen(this, "/onlineLogPage", {
                    "appId": this.requestForm.appId,
                    "deviceId": device.id
                })
            }
        },
        showPushDialog(device) {
            this.selectedDevice = device;
            this.pushMsgDialogVisible = true;
        },
        pushClick(messageContent, messageType) {
            this.pushMsgDialogVisible = false;
            if (messageContent && messageType) {
                this.pushMsg(messageContent, messageType)
            }
        },
        showTipsDialog(device) {
            this.selectedDevice = device;
            this.tipsDialogVisible = true;
        },
        tipsDialogClick(dialogTitle, dialogContent) {
            this.tipsDialogVisible = false;
            if (dialogContent && this.selectedDevice.deviceCode) {
                netWorkController.deleteDevice(this.userInfo.id, this.userInfo.accessToken, this.selectedDevice, (reslut) => {
                    if (reslut.status === 200) {
                        toastUtils.success(this, reslut.msg)
                        this.pageDeviceList()
                    } else {
                        toastUtils.warning(this, reslut.msg)
                    }
                })
            }
        },
        pushMsg(messageContent, messageType) {
            this.selectedDevice.messageType = messageType;
            this.selectedDevice.messageContent = messageContent;
            netWorkController.pushMessage(this.selectedDevice, (result) => {
                if (result.status === 200) {
                    toastUtils.success(this, result.msg)
                    setTimeout(() => {
                        window.doOpen(this, "/messageListPage", {messageSeq: result.data})
                    }, 500);
                } else {
                    toastUtils.warning(this, result.msg)
                }
            })
        },
        pageDeviceList() {
            netWorkController.devicePageList(this.userInfo.id, this.userInfo.accessToken, this.requestForm, (result) => {
                if (result.data) {
                    this.deviceList = result.data.list;
                    this.requestForm.pageNum = result.data.pageNum;
                    this.requestForm.total = result.data.total
                } else {
                    toastUtils.warning(this, result.msg)
                }
            })
        },
        formatDate(row, column, cellValue) {
            return dateUtils.timestampToDate(cellValue);
        },
        formatConnectStatus(item) {
            if (item && item.connectStatus === 1) {
                const timestamp = new Date().getTime();
                ///最后一次心跳在1分钟内表示已连接
                if (timestamp - item.lastHeartTime < (1000 * 60)) {
                    return "已连接";
                }
            }
            return "未连接";
        },
        onchange(value) {
            cookieUtils.set("appIdCache", value);
            this.pageDeviceList();
        },
        handleSizeChange(value) {
            if (value) {
                this.requestForm.pageSize = value
                this.pageDeviceList()
            }
        },
        handleCurrentChange(value) {
            if (value) {
                this.requestForm.pageNum = value;
                this.pageDeviceList()
            }
        },
    }


}